import React from 'react';
import styled from "styled-components";
import { theme } from "../../../styles/theme";
import { Dropdown } from "../../../ui";
import { useLocation } from "react-router-dom";

import kcellLogo from '../../../ui/icons/Kcell.logo.svg';
import activLogo from '../../../ui/icons/Activ.logo.svg';
import kcellAuletLogo from '../../../ui/icons/KcellAulet.logo.svg';


const logos = {
	activ: activLogo,
	kcell: kcellLogo,
	aulet: kcellAuletLogo,
}

const Root = styled.header`
    border-bottom: solid 1px;
    border-color: ${theme.colors.black_8};
`;

const HeaderContent = styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 28px 0;
		max-width: 90%;
		margin: 0 auto;
`

const LogoWrapper = styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		img {
				margin: 3px;
		}
`

const LANG_OPTIONS = [
	{ label: 'Рус', value: 'ru' },
	{ label: 'Қаз', value: 'kk' },
];

const Header = ({ lang, setLang }) => {
	const { pathname } = useLocation();

	return (
		<Root>
			<HeaderContent>
				<div>
					{
						['activ', 'kcell', 'aulet'].includes(pathname?.slice(1)) ?
						<img src={logos[pathname?.slice(1)]} alt="activ-kcell-logo"/>
							:
							<LogoWrapper>
								<img src={kcellLogo} alt="kcell-logo"/>
								<img src={activLogo} alt="activ-logo"/>
							</LogoWrapper>
					}
				</div>
				<div>
					<Dropdown
						options={LANG_OPTIONS}
						defaultOption={LANG_OPTIONS.find(l => l.value === lang)}
						onChange={(l) => setLang(l)}
					/>
				</div>
			</HeaderContent>
		</Root>
	);
};

export default Header;
